export const OmakasePlanTerms = Object.freeze({
  SHORT: 'short',
  MIDDLE: 'mid',
  LONG: 'long',
});

export const OmakasePlanTermMap = {
  [OmakasePlanTerms.SHORT]: 1,
  [OmakasePlanTerms.MIDDLE]: 2,
  [OmakasePlanTerms.LONG]: 3,
};

export const OmakasePlanPolicies = Object.freeze({
  RETURN: 'return',
  BALANCE: 'balance',
});

export const MODAL_TITLE = 'オートセレクト';
export const DESCRIPTION_BUTTON_TEXT = '解説';
export const BUDGET_TITLE = '運用金額はいくらですか？';
export const STRATEGY_TITLE = 'どのような戦略で運用したいですか？';
export const STRATEGY_SUFFIX = '戦略';
export const POLICY_TITLE = '運用方針に近いものはどちらですか？';
export const INTRO_TEXT_WEB = '3つの質問に答えるだけで、\nあなたに合った自動売買の組み合わせをご提案します。';
export const INTRO_TEXT_MOBILE = '3つの質問に答えるだけで、あなたに合った\n自動売買の組み合わせをご提案します。';
export const POLICY_BUTTON_TEXT_RETURN = '収益性を重視したい';
export const POLICY_BUTTON_TEXT_BALANCE = '安定性を重視したい';
export const CONFIRM_MODAL_INFO = '開始ボタンを押すと自動売買を開始します';
export const CONFIRM_MODAL_NAME_TEXT = 'ポートフォリオ名';
export const OMAKASE_PLAN_REQUIRED_MARGIN_TEXT = '発注証拠金合計';
export const OMAKASE_PLAN_SIMULATION_TOTAL_PL_TEXT = '総合損益';
export const OMAKASE_PLAN_SIMULATION_ROI_TEXT = '収益率';
export const OMAKASE_PLAN_START_TEXT = 'オートセレクトを開始';
export const OMAKASE_PLAN_REQUIRED_MARGIN_TOOLTIP =
  '発注証拠金合計は、各自動売買の「入力したセット数×1セットを発注するために必要な最低証拠金の目安」の合計金額です。';
export const OMAKASE_PLAN_SIMULATION_ROI_TOOLTIP = '収益率は運用資金目安の金額を投資元本としたリターンを表示。';
export const RESET_SET_COUNT_TEXT = 'セット数を元に戻す';
export const NEXT_BUTTON_TEXT = '確認画面へ進む';

// long/mid/shortの名前が実態とあっていないが流用している
export const OmakasePlanStrategyOptions = Object.freeze([
  { value: OmakasePlanTerms.LONG, name: 'レンジ' },
  { value: OmakasePlanTerms.MIDDLE, name: 'スワップ' },
  { value: OmakasePlanTerms.SHORT, name: 'トレンド' },
]);
